// iphone12 randomUUID函数不支持的兼容代码
if (!window.crypto.randomUUID) {
    window.crypto.randomUUID = async function randomUUID() {
      const data = new Uint8Array(16);
      window.crypto.getRandomValues(data);
      data[6] = (data[6] & 0x0f) | 0x40; // version 4
      data[8] = (data[8] & 0x3f) | 0x80; // variant RFC4122
  
      let uuid = '';
      for (let i = 0; i < 16; i++) {
        uuid += (data[i] + 0x100).toString(16).slice(1);
      }
  
      return uuid;
    };
  }